const ENPHASE_INSTALLER = 'enphase_installer'
const CUSTOMER_SUPPORT = 'customer_support'
const ToggleOptions = [
  {
    id: 'enphase_installer',
    label: 'Enphase Installer',
  },
  // {
  //   id: 'customer_support',
  //   label: 'Customer Support',
  // },
]

export { ToggleOptions, ENPHASE_INSTALLER, CUSTOMER_SUPPORT }
